<template>
  <div class="main-container">
    <DataReady id="content">
      <UsersDetail :userId="$store.getters.currentUserId"></UsersDetail>
    </DataReady>
  </div>
</template>

<script>
import UsersDetail from 'CORE/components/users/detail'
import DataReady from 'CORE/components/utilities/data-ready'

export default {
    name: 'UserProfileEdit',
    components: {
        DataReady,
        UsersDetail,
    },
}
</script>
